(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6635],{

/***/ 12050:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broadcast",
      function () {
        return __webpack_require__(92361);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82175);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46323);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99731);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28808);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70082);

// @ts-ignore








var BroadCast = function(param) {
    var items = param.items, countryCode = param.countryCode;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_4__/* .Namespace.Broadcast */ .l.Broadcast).t;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_7__/* .useLang */ .J)().locale;
    var formattedItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var dayMap = {};
        items.forEach(function(i) {
            var formattedDate = new Date(i.premiere).toLocaleDateString(locale);
            var _formattedDate;
            dayMap[formattedDate] = (_formattedDate = dayMap[formattedDate]) !== null && _formattedDate !== void 0 ? _formattedDate : [];
            dayMap[formattedDate].push(i);
        });
        return dayMap;
    }, [
        items
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_6__/* .basicSEO */ .F)(t("seo:broadcast_title"), t("seo:broadcast_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().broadcast),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                children: t("broadcast:broadcast_title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().video),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("broadcast:video_placeholder")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().schedule),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: t("broadcast:schedule_title")
                            }),
                            Object.keys(formattedItems).map(function(dayStamp) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: dayStamp
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().list),
                                            children: formattedItems[dayStamp].map(function(i) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                    itemProp: "play",
                                                                    children: i.title
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    itemProp: "theatre",
                                                                    children: i.theatre_title
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                                                            children: new Date(i.premiere).toLocaleTimeString(locale, {
                                                                timeStyle: "short"
                                                            })
                                                        })
                                                    ]
                                                }, i.id);
                                            })
                                        })
                                    ]
                                }, dayStamp);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (BroadCast);


/***/ }),

/***/ 82175:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"broadcast":"broadcast_broadcast__ObGdQ","video":"broadcast_video__shsYs","schedule":"broadcast_schedule__bJh4_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(12050); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);